var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500001 10.3549H22.5M2.85714 16.6406H12.2857M15.4286 16.6406H20.1429M0.500001 7.21205L0.5 19.7835C0.5 20.6514 1.20355 21.3549 2.07143 21.3549L20.9286 21.3549C21.7964 21.3549 22.5 20.6514 22.5 19.7835V7.21205C22.5 6.34418 21.7964 5.64063 20.9286 5.64063L2.07143 5.64062C1.20355 5.64062 0.500001 6.34418 0.500001 7.21205Z",
    stroke: "#595D62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C16 3.68629 18.6863 1 22 1C25.3137 1 28 3.68629 28 7C28 10.3137 25.3137 13 22 13C18.6863 13 16 10.3137 16 7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7L21.5714 9.14286L25 4.85714M22 13C18.6863 13 16 10.3137 16 7C16 3.68629 18.6863 1 22 1C25.3137 1 28 3.68629 28 7C28 10.3137 25.3137 13 22 13Z",
    stroke: "#595D62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPaid);
export default __webpack_public_path__ + "static/media/credit-card-paid.b7fa29b25f890286c7346569496c523e.svg";
export { ForwardRef as ReactComponent };